import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { FeaturesListPage } from "./FeaturesListPage";
import { FeaturePromptsPage } from "./FeaturePromptsPage";
import { RevisionPage } from "./RevisionPage";
import { TestCasesPage } from "./TestCasesPage";
import { ComparisonPage } from "./ComparisonPage";

export const PromptsPage: FC = () => {
  return (
    <Routes>
      <Route index element={<FeaturesListPage />} />
      <Route path=":featureKey" element={<FeaturePromptsPage />} />
      <Route path=":featureKey/test-cases" element={<TestCasesPage />} />
      <Route path=":featureKey/revisions/:revisionId" element={<RevisionPage />} />
      <Route path=":featureKey/revisions/:revisionId/tests/:comparisonId" element={<ComparisonPage />} />
    </Routes>
  );
};
